import React, { useEffect, useState } from "react"

import {
    Card,
    CardBody,
    Col,
    Row,
    CardTitle,
} from "reactstrap"


import { connect } from "react-redux";
import { useDispatch } from 'react-redux';

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import Loader from "components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createBatch } from "helpers/batch_helper";
import Select from "react-select"

const allDepartments = [
    { id: 1, name: "Skilling" },
    { id: 2, name: "Upskilling" },
    { id: 3, name: "Paid Trainings" },
    { id: 4, name: "Corporate" },
    { id: 5, name: "School Project" },
    { id: 6, name: "University & College" },
    { id: 7, name: "Skill Development" },
    { id: 8, name: "BHR" },
    { id: 9, name: "Safety" },
    { id: 10, name: "Employee Relations" },
    { id: 11, name: "Environment" },
    { id: 12, name: "Others" },
]

const allBatchTypes = [
    { id: 1, name: "Internal" },
    { id: 2, name: "External" },

]

const CreateGroup = (props) => {
    document.title = "Content Management | Create Batch";

    const breadcrumbItems = [
        { title: "Batch", link: "#" },
        { title: "Create Batch", link: "#" },
    ]

    useEffect(() => {
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])

    useEffect(() => {
        props.setBreadcrumbItems('Create Batch', breadcrumbItems)
    }, [])

    const [batchName, setBatchName] = useState("");
    const [batchType, setBatchType] = useState(null);
    const [department, setDepartment] = useState(null);
    const [loader, setLoader] = useState(false);
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [typeSpanDisplay, setTypeSpanDisplay] = useState("none");
    const [deptSpanDisplay, setDeptSpanDisplay] = useState("none");
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validation
        let hasError = false;
        
        if (!batchName) {
            setSpanDisplay("inline");
            hasError = true;
        } else {
            setSpanDisplay("none");
        }
        
        if (!batchType) {
            setTypeSpanDisplay("inline");
            hasError = true;
        } else {
            setTypeSpanDisplay("none");
        }
        
        if (!department) {
            setDeptSpanDisplay("inline");
            hasError = true;
        } else {
            setDeptSpanDisplay("none");
        }
        
        if (hasError) {
            toast.error("Please fill all required fields");
            return;
        }

        try {
            setLoader(true);
            const result = await createBatch({ 
                batchName: batchName,
                batchType: batchType.name,
                department: department.name 
            });
            
            if (result?.success) {
                toast.success(result?.message || "Batch created successfully");
                setBatchName("");
                setBatchType(null);
                setDepartment(null);
                // Optionally navigate to batch list
                // navigate("/batch-list");
            } else {
                toast.error(result?.message || "Failed to create batch");
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    const handleBatchTypeChange = (selectedValue) => {
        setBatchType(selectedValue);
        setTypeSpanDisplay("none");
    }

    const handleDepartmentChange = (selectedValue) => {
        setDepartment(selectedValue);
        setDeptSpanDisplay("none");
    }

    const handleBatchNameChange = (e) => {
        setBatchName(e.target.value);
        setSpanDisplay("none");
    }

    return (
        <React.Fragment>
            {loader ? (
                <Loader />
            ) : ("")}
            <Row>
                <Col>
                    <Card>
                        <CardBody className="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-xs-12" style={{ height: "60vh" }}>
                            <CardTitle className="h4">Create Batch</CardTitle>
                            <form onSubmit={handleSubmit}>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="batch-name-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Batch Name <span className="text-danger">*</span>
                                    </label>
                                    <div className="col-md-10">
                                        <input 
                                            type="text"
                                            id="batch-name-input"
                                            className='form-control'
                                            placeholder="Enter Batch Name"
                                            maxLength="50"
                                            value={batchName}
                                            onChange={handleBatchNameChange} 
                                        />
                                        {!batchName && <span style={{ color: "red", display: spanDisplay, fontSize: "12px", marginTop: "5px" }}>
                                            This field is required
                                        </span>}
                                    </div>
                                </Row>
                                
                                <Row className="mb-3">
                                    <label
                                        htmlFor="batch-type-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Batch Type <span className="text-danger">*</span>
                                    </label>
                                    <div className="col-md-10">
                                        <Select
                                            id="batch-type-input"
                                            value={batchType}
                                            onChange={handleBatchTypeChange}
                                            options={allBatchTypes}
                                            getOptionLabel={option => option.name}
                                            getOptionValue={option => option.id.toString()}
                                            classNamePrefix="select2-selection"
                                            placeholder="Select Batch Type..."
                                            isClearable
                                        />
                                        {!batchType && <span style={{ color: "red", display: typeSpanDisplay, fontSize: "12px", marginTop: "5px" }}>
                                            Please select a batch type
                                        </span>}
                                    </div>
                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="department-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Batch Department <span className="text-danger">*</span>
                                    </label>
                                    <div className="col-md-10">
                                        <Select
                                            id="department-input"
                                            value={department}
                                            onChange={handleDepartmentChange}
                                            options={allDepartments}
                                            getOptionLabel={option => option.name}
                                            getOptionValue={option => option.id.toString()}
                                            classNamePrefix="select2-selection"
                                            placeholder="Select Department..."
                                            isClearable
                                        />
                                        {!department && <span style={{ color: "red", display: deptSpanDisplay, fontSize: "12px", marginTop: "5px" }}>
                                            Please select a department
                                        </span>}
                                    </div>
                                </Row>

                                <Row className="mb-3">
                                    <div className="mt-4 d-flex gap-2">
                                        <button type="submit" className="btn btn-primary w-md">
                                            <i className="fas fa-plus me-2"></i>Create Batch
                                        </button>
                                        <button 
                                            type="button" 
                                            className="btn btn-secondary w-md"
                                            onClick={() => {
                                                setBatchName("");
                                                setBatchType(null);
                                                setDepartment(null);
                                                setSpanDisplay("none");
                                                setTypeSpanDisplay("none");
                                                setDeptSpanDisplay("none");
                                            }}
                                        >
                                            <i className="fas fa-times me-2"></i>Clear
                                        </button>
                                    </div>
                                </Row>

                                {/* Summary of selected values */}
                                {(batchName || batchType || department) && (
                                    <div className="mt-3 p-3 bg-light rounded">
                                        <h6 className="mb-2">Batch Summary:</h6>
                                        <div className="d-flex flex-wrap gap-3">
                                            {batchName && (
                                                <span className="badge bg-primary p-2">
                                                    <i className="fas fa-tag me-1"></i>
                                                    {batchName}
                                                </span>
                                            )}
                                            {batchType && (
                                                <span className="badge bg-success p-2">
                                                    <i className="fas fa-layer-group me-1"></i>
                                                    {batchType.name}
                                                </span>
                                            )}
                                            {department && (
                                                <span className="badge bg-info p-2">
                                                    <i className="fas fa-building me-1"></i>
                                                    {department.name}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(CreateGroup);



// import React, { useEffect, useState } from "react"
// import {
//     Card,
//     CardBody,
//     Col,
//     Row,
//     CardTitle,
// } from "reactstrap"
// import { connect } from "react-redux";
// import { useDispatch } from 'react-redux';

// //Import Action to copy breadcrumb items from local state to redux state
// import { setBreadcrumbItems } from "../../store/actions";
// import Loader from "components/Loader/Loader";
// import { useNavigate, useLocation } from "react-router-dom";
// import { toast } from "react-toastify";
// import { createBatch } from "helpers/batch_helper";
// import Select from "react-select"

// const allDepartments = [
//     { id: 1, name: "Skilling" },
//     { id: 2, name: "Upskilling" },
//     { id: 3, name: "Paid Trainings" },
//     { id: 4, name: "Corporate" },
//     { id: 5, name: "School Project" },
//     { id: 6, name: "University & College" },
//     { id: 7, name: "Skill Development" },
//     { id: 8, name: "BHR" },
//     { id: 9, name: "Safety" },
//     { id: 10, name: "Employee Relations" },
//     { id: 11, name: "Environment" },
//     { id: 12, name: "Others" },
// ]

// const CreateBatchFromTraining = (props) => {
//     document.title = "Content Management | Create Batch from Training";

//     const breadcrumbItems = [
//         { title: "Training", link: "/training-calendar" },
//         { title: "Create Batch", link: "#" },
//     ]

//     const location = useLocation();
//     const navigate = useNavigate();
//     const [loader, setLoader] = useState(false);
//     const [spanDisplay, setSpanDisplay] = useState("none");
//     const [trainingData, setTrainingData] = useState(null);
    
//     // Batch form state
//     const [batchName, setBatchName] = useState("");
//     const [department, setDepartment] = useState(null);
//     const [description, setDescription] = useState("");

//     useEffect(() => {
//         const blurDiv = document.getElementById("blur");
//         var width = window.innerWidth;
//         if (width <= 994) {
//             blurDiv.click()
//         }
//     }, [])

//     useEffect(() => {
//         props.setBreadcrumbItems('Create Batch from Training', breadcrumbItems)
//     })

//     // Get training data from navigation state
//     useEffect(() => {
//         if (location.state?.trainingData) {
//             const training = location.state.trainingData;
//             setTrainingData(training);
            
//             // Pre-fill batch data based on training
//             setBatchName(training.batchName || `${training.trainingName}_Batch_${new Date().getTime()}`);
            
//             // Auto-select department based on training type
//             const suggestedDept = getDepartmentFromTrainingType(training.trainingType);
//             if (suggestedDept) {
//                 const deptObj = allDepartments.find(dept => dept.name === suggestedDept);
//                 setDepartment(deptObj);
//             }

//             // Set description with training info
//             setDescription(`Batch created from training: ${training.trainingName}. Location: ${training.depot}, ${training.state}. Duration: ${training.trainingDays} days.`);
//         } else {
//             // Redirect back if no training data
//             toast.error("No training data found. Please select a training first.");
//             navigate('/training-calendar');
//         }
//     }, [location, navigate]);

//     const getDepartmentFromTrainingType = (trainingType) => {
//         const departmentMap = {
//             'Safety': 'Safety',
//             'Driver': 'Skilling',
//             'Technician': 'Skilling',
//             'IT': 'Upskilling'
//         };
//         return departmentMap[trainingType] || 'Skilling';
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
        
//         if (!batchName || !department) {
//             setSpanDisplay("inline");
//             toast.error("Please fill all required fields");
//             return;
//         }

//         try {
//             setLoader(true);
            
//             const batchPayload = {
//                 batchName: batchName,
//                 department: department.name,
//                 description: description,
//                 trainingId: trainingData?.trainingId,
//                 trainingType: trainingData?.trainingType,
//                 depot: trainingData?.depot,
//                 state: trainingData?.state,
//                 startDate: trainingData?.startDate,
//                 endDate: trainingData?.endDate
//             };

//             const result = await createBatch(batchPayload);
            
//             if (result?.success) {
//                 toast.success(result?.message);
                
//                 // Ask user if they want to go to batch details or create another
//                 if (window.confirm("Batch created successfully! Would you like to go to the batch details page?")) {
//                     navigate(`/batch-details/${result.result.id}`);
//                 } else {
//                     // Reset form for new batch creation
//                     setBatchName("");
//                     setDescription("");
//                     // Keep the department selected for consistency
//                 }
//             } else {
//                 toast.error(result?.message);
//             }
//         } catch (error) {
//             console.error("Error creating batch:", error);
//             toast.error(error?.response?.data?.message || "Failed to create batch");
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleBackToCalendar = () => {
//         navigate('/training-calendar');
//     };

//     return (
//         <React.Fragment>
//             {loader && <Loader />}
            
//             <Row>
//                 <Col>
//                     <Card>
//                         <CardBody className="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-xs-12">
//                             <div className="d-flex justify-content-between align-items-center mb-4">
//                                 <CardTitle className="h4 mb-0">Create Batch from Training</CardTitle>
//                                 <button 
//                                     type="button" 
//                                     className="btn btn-secondary"
//                                     onClick={handleBackToCalendar}
//                                 >
//                                     ← Back to Calendar
//                                 </button>
//                             </div>

//                             {/* Training Information Card */}
//                             {trainingData && (
//                                 <Card className="mb-4" style={{ backgroundColor: '#f8f9fa' }}>
//                                     <CardBody>
//                                         <h6 className="text-primary mb-3">Training Information</h6>
//                                         <Row>
//                                             <Col md={6}>
//                                                 <p><strong>Training Name:</strong> {trainingData.trainingName}</p>
//                                                 <p><strong>Type:</strong> 
//                                                     <span className="badge bg-primary ms-2">
//                                                         {trainingData.trainingType}
//                                                     </span>
//                                                 </p>
//                                                 <p><strong>Depot:</strong> {trainingData.depot}</p>
//                                             </Col>
//                                             <Col md={6}>
//                                                 <p><strong>Location:</strong> {trainingData.state}</p>
//                                                 <p><strong>Start Date:</strong> {new Date(trainingData.startDate).toLocaleDateString()}</p>
//                                                 <p><strong>End Date:</strong> {new Date(trainingData.endDate).toLocaleDateString()}</p>
//                                                 <p><strong>Duration:</strong> {trainingData.trainingDays} day(s)</p>
//                                             </Col>
//                                         </Row>
//                                     </CardBody>
//                                 </Card>
//                             )}

//                             <form onSubmit={handleSubmit}>
//                                 <Row className="mb-3">
//                                     <label
//                                         htmlFor="batch-name"
//                                         className="col-md-2 col-form-label"
//                                     >
//                                         Batch Name *
//                                     </label>
//                                     <div className="col-md-10">
//                                         <input 
//                                             type="text"
//                                             className='form-control'
//                                             placeholder="Enter Batch Name"
//                                             maxLength="50"
//                                             value={batchName}
//                                             onChange={(e) => setBatchName(e.target.value)}
//                                             id="batch-name"
//                                         />
//                                         {!batchName && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
//                                     </div>
//                                 </Row>

//                                 <Row className="mb-3">
//                                     <label
//                                         htmlFor="batch-department"
//                                         className="col-md-2 col-form-label"
//                                     >
//                                         Department *
//                                     </label>
//                                     <div className="col-md-10">
//                                         <Select
//                                             value={department}
//                                             onChange={setDepartment}
//                                             options={allDepartments}
//                                             getOptionLabel={option => option.name}
//                                             getOptionValue={option => option.id.toString()}
//                                             classNamePrefix="select2-selection"
//                                             placeholder="Select Department"
//                                             id="batch-department"
//                                         />
//                                         {!department && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
//                                     </div>
//                                 </Row>

//                                 <Row className="mb-3">
//                                     <label
//                                         htmlFor="batch-description"
//                                         className="col-md-2 col-form-label"
//                                     >
//                                         Description
//                                     </label>
//                                     <div className="col-md-10">
//                                         <textarea
//                                             className='form-control'
//                                             placeholder="Enter batch description (optional)"
//                                             rows="3"
//                                             value={description}
//                                             onChange={(e) => setDescription(e.target.value)}
//                                             id="batch-description"
//                                         />
//                                     </div>
//                                 </Row>

//                                 <Row className="mb-3">
//                                     <div className="mt-4">
//                                         <button type="submit" className="btn btn-primary w-md me-2">
//                                             Create Batch
//                                         </button>
//                                         <button 
//                                             type="button" 
//                                             className="btn btn-outline-secondary"
//                                             onClick={handleBackToCalendar}
//                                         >
//                                             Cancel
//                                         </button>
//                                     </div>
//                                 </Row>
//                             </form>

//                         </CardBody>
//                     </Card>
//                 </Col>
//             </Row>
//         </React.Fragment>
//     )
// }

// export default connect(null, { setBreadcrumbItems })(CreateBatchFromTraining);